export const computeOrderDetailsProductWeight = ({
  products,
}: {
  products?: { weight?: number; productWeightInKg?: number }[];
}): number => {
  return (
    products?.reduce((acc, product) => {
      return acc + (product.weight ?? product.productWeightInKg ?? 0);
    }, 0) ?? 0
  );
};
